/** Maps select labels to database enum values before API calls. */
const TextTransformDatabaseEnum = (text) => {
  const textList = {
    'main dish': 'main_dish',
    'power side': 'power_side',
    'drink or dessert or treat': 'drink_dessert_treat',
    'main course': 'main_course',
  };
  return textList[text] || text;
};

export default TextTransformDatabaseEnum;
